import PopupMessage from "shared/components/PopupMessage";
import { useGetCoordinates } from "./useGetCoordinates";
import { normaliseValue } from "shared/helpers/unitHelpers";

interface GetCoordinatesProps {
  imperialUnits: boolean;
}

const GetCoordinates: React.FC<GetCoordinatesProps> = ({ imperialUnits }) => {
  const [calculatedCoordinates, closePanel] = useGetCoordinates();

  const units: Parameters<typeof normaliseValue>[2] = imperialUnits
    ? "imperial"
    : "metric";

  if (!calculatedCoordinates) {
    return null;
  }

  return (
    <PopupMessage
      closeButton="Close"
      closePanel={closePanel}
      children={
        "message" in calculatedCoordinates ? (
          <p>{calculatedCoordinates.message}</p>
        ) : (
          <>
            <p>
              Coordinates at selected point:&nbsp;
              {normaliseValue(calculatedCoordinates.lng, "coordinates")}
              {", "}
              {normaliseValue(calculatedCoordinates.lat, "coordinates")}
            </p>
            <p>
              Altitude:&nbsp;
              {normaliseValue(
                calculatedCoordinates.altitude,
                "altitude",
                units
              )}
            </p>
          </>
        )
      }
    />
  );
};

export default GetCoordinates;
